import React, {useState} from 'react';
import './DesktopRegister.css';
import Login from "../../Pages/Login/Login";
import {useNavigate} from "react-router-dom";
import Registration from "../../Pages/Registration/Registration";

const DesktopRegister = () => {

    return (
        <div className={'desktop-register-page'}>
            <Registration />
            <div className={'bg-pic-register-desktop'}></div>
        </div>
    );
};

export default DesktopRegister;